import { render } from "./basicInform.vue?vue&type=template&id=1a085972&scoped=true"
import script from "./basicInform.vue?vue&type=script&lang=js"
export * from "./basicInform.vue?vue&type=script&lang=js"

import "./basicInform.vue?vue&type=style&index=0&id=1a085972&lang=scss&scoped=true"
import "./basicInform.vue?vue&type=style&index=1&id=1a085972&lang=scss&scoped=true"
import "./basicInform.vue?vue&type=style&index=2&id=1a085972&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a085972"]])

export default __exports__